import "./gameDisplay.scss";
import { Stack, Box, Button } from "@mui/material";
import { getTeamFromString } from "../../../models/Team";
import { Link } from "react-router-dom";
import { Game } from "../../../models/Game";
import GameDisplay from "./GameDisplay";
import {
  useLeagueEnvironment,
  useLeaguePaths,
} from "../../../data/LeagueEnvironmentProvider";
import { GameDisplayHeight } from "./Constants";

interface Props {
  game: Game;
}

export default function UpcomingGame({ game }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, opp] = game.opponentInfo.split(" ");
  const environment = useLeagueEnvironment();
  const oppTeam = getTeamFromString(opp, environment);
  const { getReportsTeamPath } = useLeaguePaths();

  return (
    <Stack
      direction="row"
      className="game-display--container"
      sx={{ height: GameDisplayHeight }}
    >
      <GameDisplay game={game} />
      <Box className="game-display--button-container">
        <Button
          component={Link}
          to={`${getReportsTeamPath(oppTeam.abbrev)}`}
          className="game-display--report-link"
        >
          Team Report
        </Button>
      </Box>
    </Stack>
  );
}
